import OnboardingVideoModal from "./OnboardingVideoModal";
export default OnboardingVideoModal;
